import { MainLayout } from "@/components/layout/MainLayout";
import { PageTransition } from "@/components/layout/PageTransition";
import { HeroSection } from "@/components/sections/HeroSection";
import { FeaturesSection } from "@/components/sections/FeaturesSection";
import { OnboardingTour } from "@/components/onboarding/OnboardingTour";
import { useOnboarding, type TourStep } from "@/hooks/useOnboarding";
import { Button } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";
import { useEffect } from "react";

const tourSteps: TourStep[] = [
  {
    id: 'hero-cta',
    target: '[data-tour="hero-cta"]',
    title: 'Welcome to GenAI Hub!',
    content: 'Start your journey by configuring your AI infrastructure with our interactive wizard.',
    placement: 'bottom',
  },
  {
    id: 'features',
    target: '[data-tour="features"]',
    title: 'Explore Our Tools',
    content: 'Access powerful tools for demos, sizing, cost analysis, and deployment planning.',
    placement: 'top',
  },
  {
    id: 'navigation',
    target: '[data-tour="navigation"]',
    title: 'Quick Navigation',
    content: 'Use the navigation menu to access all features. The Wizard button gets you started quickly.',
    placement: 'bottom',
  },
];

const Index = () => {
  const tour = useOnboarding(tourSteps);

  useEffect(() => {
    // Auto-start tour for first-time users
    if (!tour.hasCompleted) {
      const timer = setTimeout(() => {
        tour.start();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [tour.hasCompleted]);

  return (
    <MainLayout>
      <PageTransition>
        {tour.isActive && tour.currentStepData && (
          <OnboardingTour
            step={tour.currentStepData}
            currentStep={tour.currentStep}
            totalSteps={tour.totalSteps}
            onNext={tour.next}
            onPrevious={tour.previous}
            onSkip={tour.skip}
          />
        )}

        <div className="fixed bottom-6 right-6 z-30">
          <Button
            size="icon"
            className="rounded-full shadow-elegant h-12 w-12"
            onClick={tour.start}
            title="Start tour"
          >
            <HelpCircle className="h-5 w-5" />
          </Button>
        </div>

        <HeroSection />
        <FeaturesSection />
      </PageTransition>
    </MainLayout>
  );
};

export default Index;
